<script>
import PushNotification from "@/models/User/PushNotification";

export default {
    data() {
        return {
            elevation: 10,
            timeoutTimer: null,
        }
    },
    props: {
        pushNotification: {
            type: PushNotification,
            required: true,
        }
    },
    methods: {
        autoDelete() {
            if (this.pushNotification.timeout) {
                this.timeoutTimer = setTimeout(() => {
                    this.close();
                }, this.pushNotification.timeout);
            }
        },
        close() {
            clearTimeout(this.timeoutTimer);
            this.pushNotification.$delete();
        }
    },
    created() {
        this.autoDelete();
    }
}
</script>
